module.exports = __webpack_public_path__ + "img/yinhejiqi.2642f499.png";